import { render, staticRenderFns } from "./FarmsList.vue?vue&type=template&id=b39faf80&scoped=true&"
import script from "./FarmsList.vue?vue&type=script&lang=ts&"
export * from "./FarmsList.vue?vue&type=script&lang=ts&"
import style0 from "./farms-list.scss?vue&type=style&index=0&id=b39faf80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39faf80",
  null
  
)

export default component.exports